import { IconLayer } from '@deck.gl/layers';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Colors } from '../../../constants/colors';
import { ICON_MAPPING } from '../../../constants/path-layer';
import { getCoordinates } from '../../../helpers/geojson';
import { getMapATMs } from '../../../helpers/map-link';
import AtmBounds from '../../../models/AtmBounds';
import {
  activeMapSelector,
  isEditableSelector
} from '../../../store/selectors/mapSelectors';

/**
 * Layer that renders atm icons, it has its own model
 */
const useAtmLayer = () => {
  const activeMap = useSelector(activeMapSelector);
  const isEditMode = useSelector(isEditableSelector);

  const layers = useMemo(
    () => {
      const isLayerHidden = isEditMode || !activeMap;
      if (isLayerHidden) {
        return null;
      }

      return getMapATMs(activeMap).map(feature => {
        return new IconLayer({
          id: feature.properties.id,
          billboard: true,
          iconAtlas: 'images/path-layer.png',
          iconMapping: ICON_MAPPING,
          data: [new AtmBounds(feature)],
          pickable: true,
          sizeMaxPixels: 200,
          sizeScale: 1,
          sizeUnits: 'meters',
          visible: true,
          getIcon: () => 'atm',
          getPosition: icon => getCoordinates(icon.getCenter()),
          getSize: () => 200,
          getColor: () => Colors.pathColor
        });
      });
    },
    [activeMap, isEditMode]
  );

  return layers;
};

export default useAtmLayer;
